import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Button, Form, Container } from 'react-bootstrap';
import { $api } from '../../../helpers/api';
import './UpdateCardInfo.css';

const UpdateCardInfo = () => {
  const { id } = useParams();
  const [post, setPost] = useState({});
  const [formData, setFormData] = useState({
     title_ka: "", 
  titleEng: "", 
  description_ka: "", 
  descriptionEng: "",
  fullDescription: "", 
  fullDescription_ka: "",
  imageUrl: "",
  });

  useEffect(() => {
    $api.get(`/posts/byId/${id}`).then(response => {
      setPost(response.data);
      setFormData(prev => ({ ...prev, ...response.data }));
    });
  }, [id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const editPost = async e => {
    e.preventDefault();
    const updatedFields = Object.keys(formData).reduce((acc, key) => {
      if (formData[key] !== post[key]) acc[key] = formData[key];
      return acc;
    }, {});

    if (Object.keys(updatedFields).length > 0) {
      try {
        await $api.put(`/posts/update/${id}`, updatedFields, {
          headers: { accessToken: localStorage.getItem('accessToken') },
        });
        alert('Post updated successfully!');
      } catch (error) {
        console.error('Update failed:', error);
      }
    }
  };

  return (
    <Container>
      <div className='update-post-page full-post-page'>
        <Row className='full-post-page-row'>
          <Col className='post-image-column'>
            <img src={post.imageUrl} alt='post-img' />
          </Col>
        </Row>
        <Form onSubmit={editPost}>
          {Object.keys(formData).map(key => (
            <Form.Group key={key} id='inputCreatePost'>
              <Form.Label>{key}:</Form.Label>
              <Form.Control
                name={key}
                value={formData[key] || ''}
                onChange={handleChange}
                type={key.includes('Description') ? 'textarea' : 'text'}
                placeholder={post[key] || ''}
              />
            </Form.Group>
          ))}
          <Button type='submit'>განახლება</Button>
        </Form>
      </div>
    </Container>
  );
};

export default UpdateCardInfo;